<div class="snackbar" *ngIf="showSnackbar">
  <span class="message">{{ message }}</span>
  <button class="close" (click)="closeSnackbar()">X</button>
</div>
